<template>
  <div :class="alert.type" class="alert">
    <div v-if="alert.headline" class="alert__title">{{ alert.headline }}</div>
    <div class="alert__content">
			{{ alert.message }}
		</div>
    <!-- An alert that asks a question needs a way to answer it; without one
         the only exits are the actions that caused the warning. -->
    <button
      v-if="alert.action"
      type="button"
      class="alert__action"
      @click="actionTake"
    >{{ alert.action }}</button>
    <i
      class="fas fa-times alert__close"
      @click="closeAlert"
    ></i>
  </div>
</template>

<script>
export default {
	props: {
		alert: {
			type: Object
		},
	},
	emits: ['close-alert', 'alert-action'],
	setup(props, { emit }){

		function closeAlert(){
			emit("close-alert")
		}

		function actionTake(){
			emit("alert-action")
		}

		return { closeAlert, actionTake }
	}
};
</script>

<style lang="scss">
@use "@/scss/items/alert/alert";

.alert__action {
  flex: none;
  margin-right: 28px;
  padding: 4px 10px;
  border: 1px solid currentColor;
  border-radius: 4px;
  background: transparent;
  color: inherit;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
}
</style>
